<mat-dialog-content>
  <div id="confirm-dialog-wrapper">

    <div id="confirm-dialog-title" *ngIf="data.title">{{data.title}}</div>
    <div id="confirm-dialog-question">{{data.question}}</div>
    <div id="buttons-wrapper">
      <button id="btn-cancel" (click)="cancel()">Cancel</button>
      <button id="btn-continue"
              (click)="confirm()">{{data.confirmButtonAltText ? data.confirmButtonAltText : 'Delete'}}</button>
    </div>
  </div>
</mat-dialog-content>
